module.exports = __webpack_public_path__ + "img/java.e00a94af.png";